(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pretty-product-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pretty-product-offer')) {
    customElements.define('pretty-product-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.timerEnabled !== 'true') return;
        const value = this.dataset.end;
        if (!value || !/(Z|[+-]\d{2}:\d{2})$/.test(value)) return;
        const end = Date.parse(value);
        if (!Number.isFinite(end)) return;
        const timer = this.querySelector('.pretty-product-offer__timer');
        const clock = this.querySelector('time');
        const tick = () => {
          const seconds = Math.max(0, Math.floor((end - Date.now()) / 1000));
          if (seconds === 0) {
            this.hidden = true;
            clearInterval(this.interval);
            return;
          }
          timer.hidden = false;
          const days = Math.floor(seconds / 86400);
          const hours = Math.floor(seconds % 86400 / 3600);
          const minutes = Math.floor(seconds % 3600 / 60);
          const remainder = seconds % 60;
          clock.textContent = (days ? days + 'd ' : '') + String(hours).padStart(2, '0') + 'h ' + String(minutes).padStart(2, '0') + 'm ' + String(remainder).padStart(2, '0') + 's';
          clock.dateTime = value;
        };
        tick();
        if (!this.hidden) this.interval = setInterval(tick, 1000);
      }
      disconnectedCallback() { clearInterval(this.interval); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
